import queryString from 'query-string'
import { useLocation } from 'lib/router'
import MemberAccepted from 'views/MemberAccepted'
import { useGetWorkspaceAdminInviteDetails } from 'api/endpoints/portalAdmins'
import { useAuth } from 'auth'
import { useState } from 'react'
import { useConfirmPermissionTicket } from 'api/endpoints/permissionTicket'
import { useEffectOnce } from 'react-use'
import { useGetWorkspaceConnectedApplications } from 'api/endpoints/workspaces'
import { useAnalytics } from 'lib/simple-analytics'

const MemberAcceptedContainer = () => {
  const { loadUserProfile } = useAuth()
  const [firstName, setFirstName] = useState('')
  const [isLoading, setIsLoading] = useState(true)
  const { page } = useAnalytics()

  const location = useLocation()
  const { accessCode: id } = queryString.parse(location.search)
  const connectionId = (id as string) || ''

  const { data: adminInvite } = useGetWorkspaceAdminInviteDetails({
    invitationId: connectionId,
  })
  const permissionTicket = useConfirmPermissionTicket()
  const {
    data: connectedApplications,
    refetch: fetchApplications,
  } = useGetWorkspaceConnectedApplications({
    organizationId: adminInvite?.inviterOrganizationId || '',
    workspaceId: adminInvite?.inviterWorkspaceId || '',
  })

  useEffectOnce(() => {
    permissionTicket.mutate(
      {
        ticketId: connectionId,
      },
      {
        onSettled: () => {
          setIsLoading(false)
          fetchApplications()
        },
      }
    )

    page()
  })

  useEffectOnce(() => {
    loadUserProfile()
      .then(profile => {
        setFirstName(profile?.firstName || '')
      })
      .catch(err => {
        console.log('err', err)
      })
  })

  return (
    <MemberAccepted
      isLoading={isLoading}
      organizationName={adminInvite?.inviterOrganizationName || ''}
      workspaceName={adminInvite?.inviterWorkspaceName || ''}
      name={firstName}
      actions={connectedApplications?.results || []}
    />
  )
}

export default MemberAcceptedContainer
